import { escapeHtml } from "./leaderboard.ts";
import type { PlayerProfile } from "./player-profile.ts";

export function playerNameForm(profile: PlayerProfile, id: string, message = ""): string {
  return `<form class="leaderboard-entry player-name-form" data-profile-form>
    <label for="${id}">Your name</label>
    <div class="name-controls">
      <input id="${id}" name="display-name" data-profile-name type="text" minlength="2" maxlength="24"
        required autocomplete="nickname" value="${escapeHtml(profile.name)}" />
      <button type="submit"><i data-lucide="save" aria-hidden="true"></i>Save name</button>
    </div>
    <label class="auto-join-preference"><input type="checkbox" name="auto-join" ${profile.autoJoin ? "checked" : ""} />Automatically post my future solves</label>
    <p role="status" class="name-status" data-profile-status>${escapeHtml(message)}</p>
  </form>`;
}